export class DataProcessingHelper {

  /**
   * Scale a value from one range to another
   * Example of use:
   *
   * // Convert 33 from a 0-100 range to a 0-65535 range
   * var n = scaleValue(33, [0,100], [0,65535]);
   *
   * // Ranges don't have to be positive
   * var n = scaleValue(0, [-50,+50], [0,65535]);
   *
   * Ranges are defined as arrays of two values, inclusive
   *
   * The ~~ trick on return value does the equivalent of Math.floor, just faster.
   *
   */
  public static scaleValue(value, from, to) {
    const scale = (to[1] - to[0]) / (from[1] - from[0]);
    const capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    // eslint-disable-next-line no-bitwise
    return ~~(capped * scale + to[0]);
  }


  /**
   * finds the intersection of
   * two arrays in a simple fashion.
   *
   * PARAMS
   *  a - first array, must already be sorted
   *  b - second array, must already be sorted
   *
   * NOTES
   *
   *  Should have O(n) operations, where n is
   *    n = MIN(a.length(), b.length())
   *
   * @param a
   * @param b
   */
  public static intersectSafe(a, b) {
    let ai = 0;
    let bi = 0;
    const result = [];

    while (ai < a.length && bi < b.length) {
      if (a[ai] < b[bi]) {
        ai++;
      } else if (a[ai] > b[bi]) {
        bi++;
      } else {
        /* they're equal */
        result.push(a[ai]);
        ai++;
        bi++;
      }
    }
    return result;
  }

  /**
   * Convert a type of object to an array of data
   * Example of use:
   *
   * // Convert map keys in shape-map-keys component 
   * to have an array of column names and column data
   *
   */
  public static prepareMapKeysDataForCSVExport(keys: Object): Array<any> {
    const data = []
    
    for(var propt in keys){
      data.push({ columnName: propt, data: keys[propt] });
    }

    return data
  }
}
